import z from "zod";

const translationPath = "page.4uDlist.listFiles.errors.";

const purposeSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const integrationTypeSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const listClassificationSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  { invalid_type_error: translationPath + "list_classification" }
);
export const listFileSchema = z
  .object({
    file: z.any(),
    purposes: z.array(purposeSchema).min(1, translationPath + "purposes"),
    integrationType: integrationTypeSchema.nullish(),
    listClassification: listClassificationSchema,
  })
  .superRefine((val, ctx) => {
    if (!val.file) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "file",
        path: ["file"],
      });
    }
  });

export type TListFileForm = z.infer<typeof listFileSchema>;
